import { useEffect } from 'react';

import type { ThemeState } from '@atlaskit/tokens';

import { useThemingState } from './useThemingState.ts';

// This hook relies on state upon init and can be used in situations where re-render after init is acceptable
export const useInitializeTheme = (initialTheme?: Partial<ThemeState>): boolean => {
	const [{ isInitialized }, { initializeTheme }] = useThemingState();

	useEffect(() => {
		void initializeTheme(initialTheme);
		// Only execute upon initial render
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isInitialized;
};
